/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { CreateEnumerationEvaluationParameterDto } from './CreateEnumerationEvaluationParameterDto';
import {
    instanceOfCreateEnumerationEvaluationParameterDto,
    CreateEnumerationEvaluationParameterDtoFromJSON,
    CreateEnumerationEvaluationParameterDtoFromJSONTyped,
    CreateEnumerationEvaluationParameterDtoToJSON,
} from './CreateEnumerationEvaluationParameterDto';
import type { CreateNumericEvaluationParameterDto } from './CreateNumericEvaluationParameterDto';
import {
    instanceOfCreateNumericEvaluationParameterDto,
    CreateNumericEvaluationParameterDtoFromJSON,
    CreateNumericEvaluationParameterDtoFromJSONTyped,
    CreateNumericEvaluationParameterDtoToJSON,
} from './CreateNumericEvaluationParameterDto';

/**
 * @type CreateEvaluationParameterDto
 * 
 * @export
 */
export type CreateEvaluationParameterDto = { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.EvaluationParameters.CreateEnumerationEvaluationParameterDto, Ptw.Ptw100.AppZero.Application.Shared' } & CreateEnumerationEvaluationParameterDto | { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.EvaluationParameters.CreateNumericEvaluationParameterDto, Ptw.Ptw100.AppZero.Application.Shared' } & CreateNumericEvaluationParameterDto;


export function CreateEvaluationParameterDtoFromJSON(json: any): CreateEvaluationParameterDto {
    return CreateEvaluationParameterDtoFromJSONTyped(json, false);
}

export function CreateEvaluationParameterDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateEvaluationParameterDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    switch (json['$type']) {
        case 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.EvaluationParameters.CreateEnumerationEvaluationParameterDto, Ptw.Ptw100.AppZero.Application.Shared':
            return {...CreateEnumerationEvaluationParameterDtoFromJSONTyped(json, true), $type: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.EvaluationParameters.CreateEnumerationEvaluationParameterDto, Ptw.Ptw100.AppZero.Application.Shared'};
        case 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.EvaluationParameters.CreateNumericEvaluationParameterDto, Ptw.Ptw100.AppZero.Application.Shared':
            return {...CreateNumericEvaluationParameterDtoFromJSONTyped(json, true), $type: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.EvaluationParameters.CreateNumericEvaluationParameterDto, Ptw.Ptw100.AppZero.Application.Shared'};
        default:
            throw new Error(`No variant of CreateEvaluationParameterDto exists with '$type=${json['$type']}'`);
    }
}

export function CreateEvaluationParameterDtoToJSON(value?: CreateEvaluationParameterDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    switch (value['$type']) {
        case 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.EvaluationParameters.CreateEnumerationEvaluationParameterDto, Ptw.Ptw100.AppZero.Application.Shared':
            return CreateEnumerationEvaluationParameterDtoToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.EvaluationParameters.CreateNumericEvaluationParameterDto, Ptw.Ptw100.AppZero.Application.Shared':
            return CreateNumericEvaluationParameterDtoToJSON(value);
        default:
            throw new Error(`No variant of CreateEvaluationParameterDto exists with '$type=${value['$type']}'`);
    }

}

/**
 * Check if a given object implements the CreateEvaluationParameterDto interface.
 */
export function instanceOfCreateEvaluationParameterDto(value: any): value is CreateEvaluationParameterDto {
    if (instanceOfCreateEnumerationEvaluationParameterDto(value)) return true;
    if (instanceOfCreateNumericEvaluationParameterDto(value)) return true;
    return false;
}

